/**
 * Normalizes text by converting to lowercase and removing extra whitespace
 * @param text Input text to normalize
 * @returns Normalized text
 */
export function normalizeText(text: string): string {
  if (!text) return '';
  return text.toLowerCase().trim().replace(/\s+/g, ' ');
}

/**
 * Checks if a text contains a specific phrase (case-insensitive)
 * @param text Text to search in
 * @param phrase Phrase to search for
 * @returns Boolean indicating if phrase was found
 */
export function containsPhrase(text: string, phrase: string): boolean {
  if (!text || !phrase) return false;
  return normalizeText(text).includes(normalizeText(phrase));
}

/**
 * Checks if text contains any of the specified phrases
 * @param text Text to search in
 * @param phrases Array of phrases to search for
 * @returns Boolean indicating if any phrase was found
 */
export function containsAnyPhrase(text: string, phrases: string[]): boolean {
  if (!text || !phrases || phrases.length === 0) return false;
  const normalizedText = normalizeText(text);
  return phrases.some(phrase => normalizedText.includes(normalizeText(phrase)));
}

/**
 * Checks if text contains all of the specified phrases
 * @param text Text to search in
 * @param phrases Array of phrases to search for
 * @returns Boolean indicating if all phrases were found
 */
export function containsAllPhrases(text: string, phrases: string[]): boolean {
  if (!text || !phrases || phrases.length === 0) return false;
  const normalizedText = normalizeText(text);
  return phrases.every(phrase => normalizedText.includes(normalizeText(phrase)));
}
